import { createServices } from 'helpers/create-services'
import apiViaticos from 'core/api-viaticos'
import { transformResponse } from 'helpers/transform-response'

const baseUrl = 'v2/papeleta'
const connection = apiViaticos

const { list, get } = createServices(baseUrl, {
    connection,
})

async function cancel(id) {
    const response = await connection.post(`${baseUrl}/cancel`, {}, { params: { id } })
    return transformResponse(response)
}

async function refund(id, params) {
    const response = await connection.post(`${baseUrl}/update-devolucion`, params, {
        params: { id },
    })
    return transformResponse(response)
}

async function upload(id, params) {
    const response = await connection.post(`${baseUrl}/upload`, params, {
        params: { id },
    })
    return transformResponse(response)
}

async function download(id) {
    const response = await connection.get(`${baseUrl}/download`, {
        params: { id },
    })
    return transformResponse(response, 'data')
}

async function generatePdf(id) {
    const response = await connection.get(`${baseUrl}/pdf`, {
        params: { id },
        responseType: 'blob',
    })
    return transformResponse(response)
}

async function getPdfData(id) {
    const response = await connection.get(`${baseUrl}/pdf-data`, { params: { id } })
    return transformResponse(response)
}

async function generatePendientesPdf(id) {
    const response = await connection.get('papeleta/pendientes-pdf', {
        params: { id },
        responseType: 'blob',
    })
    return transformResponse(response)
}

export const PapeletaService = {
    list,
    getById: get,
    generatePdf,
    getPdfData,
    cancel,
    refund,
    upload,
    download,
    generatePendientesPdf,
}
